export default {
  meta: {
    title: '踩点任务管理'
  },
};
